// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingSpinner_loader__Et96v","spin":"LoadingSpinner_spin__heaW7"};